import React, { Component } from "react";
import { connect } from "react-redux";
import * as actions from "../actions";
import { Field, reduxForm } from "redux-form";
import { required, email } from "redux-form-validators";

import "./ContactUs.css";

// const email = value =>
//   value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
//     ? 'Invalid email address'
//     : undefined;

class ContactUs extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hasErrors: true
    };
  }

  renderField(field) {
    const {
      meta: { touched, error }
    } = field;

    const errorClass = `${touched && error ? "error" : ""}`;
    const notEmpty = `${
      field.input.value && field.input.value.length ? "has_text" : ""
    }`;

    if (field.type === "radio") {
      return (
        <div className={`ib inpt_wrpr ${field.id} btn bbf`}>
          <input
            className="dn"
            type={field.type}
            {...field.input}
            id={field.id}
          />
          <label htmlFor={field.id}>{field.placeholder}</label>
        </div>
      );
    }

    return (
      <div className={`ib inpt_wrpr ${field.id} bbf ${errorClass} ${notEmpty}`}>
        <input type={field.type} {...field.input} id={field.id} />
        <label htmlFor={field.id}>
          {field.placeholder}
          <span className="form_error_text">
            {touched && error ? `(${error})` : " "}
          </span>
        </label>
      </div>
    );
  }

  renderForm() {
    const { handleSubmit } = this.props;
    return (
      <div className="email_form_wrpr">
        <p className="bf hdr">Let's Connect</p>
        <form onSubmit={handleSubmit(this.onSubmit.bind(this))}>
          <div className="form_line">
            <Field
              name="name"
              id="name"
              type="text"
              placeholder="Name"
              validate={[required()]}
              component={this.renderField}
            />

            <Field
              name="from"
              id="from"
              placeholder="Email"
              type="text"
              validate={[required(), email()]}
              component={this.renderField}
            />
          </div>

          <div className="form_line">
            <Field
              name="phone"
              id="phone"
              placeholder="Phone"
              type="text"
              component={this.renderField}
            />
            <Field
              name="company"
              id="company"
              placeholder="Company"
              type="text"
              component={this.renderField}
            />
          </div>

          <div className="form_line">
            <Field
              name="emailBody"
              id="emailBody"
              validate={[required()]}
              placeholder="Describe your project"
              type="textarea"
              component={this.renderField}
            />
          </div>

          <div className="form_line btns">
            <div className="inner_wrpr">
              <p className="bbf">Project type</p>
              <Field
                name="projectType"
                id="software"
                value="software"
                placeholder="software"
                type="radio"
                component={this.renderField}
              />

              <Field
                name="projectType"
                id="website"
                value="website"
                placeholder="website"
                type="radio"
                component={this.renderField}
              />

              <Field
                name="projectType"
                id="other"
                value="other"
                placeholder="other"
                type="radio"
                component={this.renderField}
              />
            </div>
          </div>
          <button
            className="submit_btn bslf"
            type="submit"
            disabled={this.props.invalid}
          >
            Submit
          </button>
        </form>
      </div>
    );
  }

  onSubmit(values) {
    this.props.sendEmail(values);
    this.props.reset();
  }

  render() {
    return (
      <div id="contact" className="eml_frm_wrpr">
        {this.renderForm()}
      </div>
    );
  }
}

const validations = {
  email: [required(), email()],
  name: [required()],
  emailBody: [required()]
};

let validate = values => {
  const errors = {};

  // if (!values.email) {
  //   errors.email = 'Error message';
  // }

  // if (!values.name) {
  //   errors.name = 'Your name is required';
  // }

  // if (!values.emailBody) {
  //   errors.emailBody = 'Please enter a message';
  // }

  for (let field in validations) {
    let value = values[field];
    errors[field] = validations[field]
      .map(validateField => {
        return validateField(value, values);
      })
      .find(x => x);
  }
  return errors;
};

export default reduxForm({
  validate,

  form: "EmailForm"
})(
  connect(
    null,
    actions
  )(ContactUs)
);



// WEBPACK FOOTER //
// ./src/components/ContactUs.js